import * as angular from 'angular';

import { DigitalCorrespondanceTable } from '@models/index';
import { IDispatcherService, IDispatcher } from '..';
import { IDigitalCorrespondanceTableActionsService } from './digitalCorrespondanceTables.actionCreator';

export interface IDigitalCorrespondanceTableStoreService {
    getAll(force?: boolean): angular.IPromise<DigitalCorrespondanceTable[]>;
    getOne(guid: string, force?: boolean): angular.IPromise<DigitalCorrespondanceTable>;
    addOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable>;
    updateOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable>;
    deleteOne(guid: string): angular.IPromise<void>;
}

export interface IDigitalCorrespondanceTableActionDispatcherService extends IDispatcherService<IDigitalCorrespondanceTableStoreService> { }

export class DigitalCorrespondanceTableActionDispatcherService implements IDigitalCorrespondanceTableActionDispatcherService {
    static serviceId = 'digitalCorrespondanceTableActionDispatcherService';

    static $inject = ['digitalCorrespondanceTableActionsService'];

    constructor(private _actionService: IDigitalCorrespondanceTableActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IDigitalCorrespondanceTableStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                addOne: (target: DigitalCorrespondanceTable) => dispatch(actionService.addOne(target)),
                updateOne: (target: DigitalCorrespondanceTable) => dispatch(actionService.updateOne(target)),
                deleteOne: (guid: string) => dispatch(actionService.deleteOne(guid))
            }
        };
    }
}